<template>
    <button
        class="m-versions versions"
        type="button"
        :aria-label="ariaLabel"
        @click="showSupportModal"
    >
        <span class="version__text">
            {{$t('m-version-text')}}
        </span>
        <svg-icon
            original
            name="icons/write-us"
            class="version__icon"
        />
    </button>
</template>

<script>

import { SHOW_MODAL } from '../../../utils/constants/bus-events-constants';
    
export default {
    name: 'MVersions',
    props: {
        ariaLabel: {
            type: String,
            default: 'Show support modal'
        }
    },
    methods: {
        showSupportModal() {
            const params = {
                component: 'support'
            };
            this.$bus.$emit(SHOW_MODAL, params);
        }
    }
}
</script>

<style lang="scss">
@import "m-versions";   
</style>